module.exports = __webpack_public_path__ + "img/ios.819b2298.svg";